<template>
  <div>
    <v-list-item @click="to_request_details">
      <v-list-item-icon class="ml-2">
        <v-icon>mdi-eye-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>فتح</v-list-item-title>
    </v-list-item>

    <router-link style="text-decoration: none" target="_blank"
      :to="{ name: 'request_details', params: { id: item.request.id } }">
      <v-list-item>
        <v-list-item-icon class="ml-3">
          <v-icon>mdi-eye-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-title> فتح في تاب جديد</v-list-item-title>
      </v-list-item>
    </router-link>

    <v-list-item @click="getRequestCalls">
      <v-list-item-icon class="ml-3">
        <RequestCallsIcon />
      </v-list-item-icon>
      <v-list-item-title>المكالمات</v-list-item-title>
    </v-list-item>

    <v-list-item @click="convertRequest">
      <v-list-item-icon class="ml-2">
        <ConvertRequestIcon />
      </v-list-item-icon>
      <v-list-item-title>تحويل الطلب</v-list-item-title>
    </v-list-item>

    <v-list-item @click="handleRefuse">
      <v-list-item-icon class="ml-2">
        <NotAllowIcon />
      </v-list-item-icon>
      <v-list-item-title>رفض الطلب</v-list-item-title>
    </v-list-item>

    <v-list-item @click="handleProcessed">
      <v-list-item-icon class="ml-2">
        <ProcessedIcon />
      </v-list-item-icon>
      <v-list-item-title>معالجة الطلب</v-list-item-title>
    </v-list-item>

    <v-list-item @click="toOrderRequest">
      <v-list-item-icon class="ml-2">
        <OrderHistory />
      </v-list-item-icon>
      <v-list-item-title>سجل الطلب</v-list-item-title>
    </v-list-item>

    <v-list-item @click="openConfirmDialog" v-if="showProcessNeedToTurnedNew">
      <v-list-item-icon class="ml-2">
        <ProcessedIcon />
      </v-list-item-icon>
      <v-list-item-title>تمت المعالجه</v-list-item-title>
    </v-list-item>

  </div>
</template>

<script>
import { ConvertRequestIcon } from "@/assets/adminIcons/convertRequest";
import { OrderHistory } from "@/assets/adminIcons/orderHistory";
import { NotAllowIcon } from "@/assets/adminIcons/notAllowIcon";
import Axios from "axios";
import OrderRequestDialog from "@/components/AdminComponent/OrderRequestDialog.vue";
import { RequestCallsIcon } from "@/assets/adminIcons/requestCalls";
// import { ProcessedIcon } from "@/assets/adminIcons/processedIcon";

export default {
  components: {
    ConvertRequestIcon,
    OrderHistory,
    NotAllowIcon,
    // ProcessedIcon,
    RequestCallsIcon,
  },
  props: ["item"],
  data() {
    return {
      requestId: null,
    };
  },

  computed: {
    showProcessNeedToTurnedNew() {
      return window.location.pathname === "/admin/requests/need-to-turn-new";
    },
  },

  methods: {
    handleRefuse() {
      this.$store.state.refuseDialog = true;
      this.$store.state.refusedId = this.item;
    },

    handleProcessed() {
      this.$store.state.processedDialog = true;
      this.$store.state.processedId = this.item.id;
    },

    // toOrderRequest() {
    //   this.$store.state.orderRequestId = this.item.request.id;
    //   if (this.$store.state.showCards) {
    //     this.$store.state.orderRequestDialog = true;
    //   } else {
    //     this.$store.state.openOrderRequestSection = true
    //   }
    // },

    toOrderRequest() {
      this.$store.state.orderRequestId = this.item.request.id;
      if (this.$store.state.showCards) {
        this.$store.state.orderRequestDialog = true;
      } else {
        this.$store.state.openOrderRequestSection = true
      }
    },

    getRequestCalls() {
      this.$store.state.idOfRequestCalls = this.item.request.id;
      this.$store.state.openCallsDialog = true;
    },

    to_request_details() {
      const requestId = this.item.request.id;
      this.$router.push({
        name: "request_details",
        params: { id: requestId },
      });
    },

    convertRequest() {
      this.getUserAdmin();
      this.$store.state.openDialog = true;
      this.$store.state.selectId = this.item.id;
    },

    getUserAdmin() {
      let url =
        `${this.$store.state.url}/v2/employee/sales-agent-users`;
      Axios.get(url, { headers: this.request_headers() }).then((res) => {
        this.$store.state.allStatusAgent = res.data.payload;
      });
    },

    openConfirmDialog() {
      this.$emit("openConfirmDialog", this.item);
    },

  },
};
</script>